import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { ShortEncryptorService } from '../../../services/short-encryptor.service';

@Component({
	selector: 'app-org-view',
	imports: [CommonModule, FormsModule],
	providers: [DatePipe],
	templateUrl: './org-view.component.html',
	styleUrl: './org-view.component.scss',
})
export class OrgViewComponent {
	@Input() org: any;
	
	datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  loading = false;
	user: any = null;
	orgData: any = null;
	optData: number[] = [0];
	titleData: any = [
		'Login Users',
		'Contact Numbers',
		'Package Details',
		'Package History',
		'Other Data'
	]


  constructor(public dataService: DataService, private shCrypt: ShortEncryptorService) {
    //
  }

	async ngOnChanges() {
		if(this.org.org_code) {
			this.loading = true;
			await this.dataService.getSingleRecord('org-inst', this.org.org_code).then((res: any) => {
				// console.log(res);
				this.orgData = res;
				// this.orgData.push(res[0]);
				this.loading = false;
			});
		}
	}

	ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem && !this.user) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }
	}

	changeExpDate(orgd: any) {
    this.loading = true;
		const frmData: any = {
			erp_key: this.org.org_code + '-' + orgd.institute.inst_code,
			exp_date: orgd.package.exp_date
		};

		this.dataService.addNewRecord('updt-pkgexp', frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

	copyURL(erp_key: string) {
		const alURL = location.origin + '/autologin/'+erp_key;
    navigator.clipboard.writeText(alURL).then(() => {
      alert("URL copied to clipboard! paste it in separate browser."); // User feedback
    })
    .catch(err => {
      console.error("Failed to copy text: ", err);
    });
	}
}
